import { requestBuilder } from '../../http/RequestBuilder';
import type { GeneralResponse } from '../../http/types/Common';

export const useDeleteMoneyMapRuleGroup = requestBuilder.mutation<
    GeneralResponse,
    null,
    { id: string }
>({
    endpoint: ({ id }) => `/api/admin/money-map/rule-group/${id}`,
    method: 'DELETE',
});
